import '@/assets/css/fontello.css'
import '@/assets/css/reset.css'
import axios from 'axios'
import dayjs from 'dayjs'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import vmodal from 'vue-js-modal'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueCollapse from 'vue2-collapse'
import xlsx from 'xlsx'
import App from './App.vue'
import router from './router'
import store from './store'

axios.defaults.withCredentials = true

Vue.use(VueAxios, axios)
Vue.use(VueVirtualScroller)
Vue.use(VueCollapse)
Vue.use('RecycleScroller', VueVirtualScroller.RecycleScroller)
Vue.use(vmodal)
Vue.prototype.$xlsx = xlsx
Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
